import React from "react";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import RadioButton from "../../../../shared/components/RadioButton/RadioButton";
import { PaymentToken } from "../../../../pages/BankCardsPage/BankCardsTypes";
import { getCardType } from "../../../../shared/cardTypes";
import { h6Regular } from "../../../../shared/typography";

interface SavedPaymentMethodsProps {
  paymentTokens: PaymentToken[];
  selected: PaymentToken | null;
  onSelect: (token: PaymentToken) => void;
}

const useStyles = makeStyles({
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 24,
  },
  cardDetails: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    ...h6Regular,
  },
  issuerLogo: {
    width: 40,
    height: 40,
  },
  expiredTag: {
    ...h6Regular,
    color: "#F50050",
  },
});

const SavedPaymentMethods: React.FC<SavedPaymentMethodsProps> = ({
  paymentTokens,
  selected,
  onSelect,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div>
      {paymentTokens.map((token) => {
        const IssuerLogo = getCardType(token.issuer).Logo;

        return (
          <div key={token.id} className={classes.row}>
            <RadioButton
              checked={selected?.id === token.id}
              onChange={() => onSelect(token)}
              value={token.id}
              name="payment-token"
              color="#80BB34"
              disabled={token.expired}
            >
              <div className={classes.cardDetails}>
                <span>**** **** **** {token.lastFourDigits}</span>
                <IssuerLogo className={classes.issuerLogo} />
                {token.expired ? (
                  <span className={classes.expiredTag}>
                    {t("account.cardExpired")}
                  </span>
                ) : null}
              </div>
            </RadioButton>
          </div>
        );
      })}
    </div>
  );
};

export default SavedPaymentMethods;
